// extracted by mini-css-extract-plugin
module.exports = {"button":"jgp-3iloW","icon":"jgp-26HmQ","paused":"jgp-3FBpG","status":"jgp-1tD6G","logo":"jgp-1i51Q","bar":"jgp-1drAf","container":"jgp-2wT_h","wrapper":"jgp-2RtDg"};